import { OpenBookingStatusComponent } from "./booking-count-component/booking-count-component.component";
import { GlobalSettingsComponent } from "./global-settings.component";
import { MailConfigSettingComponent } from "./mail-config-setting/mail-config-setting.component";

export const GlobalSettingsRouting = [
    { path: '', redirectTo:"mail-configuration",pathMatch:'full'},
    // { path: '', component:GlobalSettingsComponent},
    { path: 'mail-configuration', component:GlobalSettingsComponent},
    { path: ':settingType', component:GlobalSettingsComponent},
    // { path: 'mail-configuration', outlet:"mail-configuration",  component: MailConfigSettingComponent}
]